import {
  createModalSystem,
  type BaseModalProps,
} from '@cartwhl/common/modals';

// Define modal payloads for applets
export type ModalPayloads = {
  // Add applet-specific modals here, for example:
  // CONFIRM_DELETE: { itemId: string; itemName: string };
};

export type ModalName = keyof ModalPayloads;
export type ModalProps<T extends ModalName> = BaseModalProps<ModalPayloads[T]>;

// Create and export the modal system
export const { useModal, ModalManager } = createModalSystem<ModalPayloads>({
  // Add lazy imports here when you add modals
});
